import * as React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { WIZARD_COLORS } from '../../../components/FormComponents/dynamicForm';
var COMPLETED_COLOR = '#17A34A';
var ACTIVE_COLOR = '#1877D2';
var PENDING_COLOR = WIZARD_COLORS.label;
var ApplicationStepRail = function (_a) {
    var steps = _a.steps, activeStepIndex = _a.activeStepIndex, completedStepIndexes = _a.completedStepIndexes, onStepSelect = _a.onStepSelect;
    return (React.createElement(Box, { className: "step-rail", component: "nav", "aria-label": "Application sections" }, steps.map(function (step, stepIndex) {
        var isActive = stepIndex === activeStepIndex;
        var isCompleted = completedStepIndexes.includes(stepIndex) && !isActive;
        var isReachable = isActive || isCompleted || stepIndex <= activeStepIndex;
        var connectorColor = stepIndex < activeStepIndex ? COMPLETED_COLOR
            : stepIndex === activeStepIndex ? ACTIVE_COLOR
                : PENDING_COLOR;
        return (React.createElement(Box, { key: step.id, sx: { display: 'flex', flexDirection: 'column', alignItems: 'center' } },
            React.createElement(ButtonBase, { onClick: function () { return onStepSelect(stepIndex); }, disabled: !isReachable, "aria-current": isActive ? 'step' : undefined, sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '6px',
                    width: '100%',
                    borderRadius: '6px',
                    padding: '4px 2px',
                    cursor: isReachable ? 'pointer' : 'not-allowed',
                } },
                React.createElement(Box, { "aria-hidden": true, sx: {
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        backgroundColor: isActive
                            ? ACTIVE_COLOR
                            : isCompleted
                                ? COMPLETED_COLOR
                                : 'transparent',
                        border: isActive || isCompleted ? 'none' : "2px solid ".concat(PENDING_COLOR),
                    } },
                    isCompleted && React.createElement(CheckIcon, { sx: { fontSize: 14, color: WIZARD_COLORS.surface } }),
                    isActive && (React.createElement(Box, { sx: {
                            width: 3.5,
                            height: 3.5,
                            borderRadius: '50%',
                            backgroundColor: WIZARD_COLORS.surface,
                            boxShadow: "0 -5px 0 ".concat(WIZARD_COLORS.surface, ", 0 5px 0 ").concat(WIZARD_COLORS.surface),
                        } })),
                    !isActive && !isCompleted && (React.createElement(Box, { sx: {
                            width: 5,
                            height: 5,
                            borderRadius: '50%',
                            backgroundColor: PENDING_COLOR,
                        } }))),
                React.createElement(Typography, { sx: {
                        fontSize: 11,
                        lineHeight: '14px',
                        textAlign: 'center',
                        fontWeight: isActive || isCompleted ? 700 : 400,
                        color: isActive
                            ? ACTIVE_COLOR
                            : isCompleted
                                ? COMPLETED_COLOR
                                : WIZARD_COLORS.muted,
                    } }, step.label)),
            stepIndex < steps.length - 1 && (React.createElement(Box, { "aria-hidden": true, sx: {
                    width: '2px',
                    height: 44,
                    margin: '6px 0',
                    borderRadius: '2px',
                    backgroundColor: connectorColor,
                } }))));
    })));
};
export default React.memo(ApplicationStepRail);
